import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  CustomProjectNameField,
  validateProjectName,
} from './CustomProjectNameField';

export const CustomProjectNameFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CustomProjectNameField',
    component: CustomProjectNameField,
    validation: validateProjectName, // This enables form-level validation
  }),
);